module.exports = __webpack_public_path__ + "img/bg_shichang.cc5aeea0.jpg";